<button
  class="button-shortlist-trigger merri-icon-button merri-common-button-bold"
  mat-stroked-button
  (click)="onShortlistClick()"
  cdkOverlayOrigin
>
  <mat-icon svgIcon="favorite_outline"></mat-icon>
  <div class="trigger-content">
    <span>Wish List</span>
    <div class="badge">{{ itemCount }}</div>
  </div>
</button>
